import { createORPCClient } from "@orpc/client";
import { RPCLink } from "@orpc/client/fetch";
import { SimpleCsrfProtectionLinkPlugin } from "@orpc/client/plugins";
import { StandardRPCJsonSerializer } from "@orpc/client/standard";
import type { ContractRouterClient } from "@orpc/contract";
import { createTanstackQueryUtils } from "@orpc/tanstack-query";
import { QueryClient } from "@tanstack/react-query";
import { ClientAPIContract } from "@workspace/client-domain/src";
import { CLIENT_ENV } from "../env";

const serializer = new StandardRPCJsonSerializer();

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      experimental_prefetchInRender: true,
      retry(failureCount, error) {
        if (error && "code" in error && error.code === "INTERNAL_SERVER_ERROR") {
          return failureCount < 3;
        }
        return false;
      },
      queryKeyHashFn(queryKey) {
        const [json, meta] = serializer.serialize(queryKey);
        return JSON.stringify({ json, meta });
      },
      staleTime: 60 * 1000,
    },
    dehydrate: {
      serializeData(data) {
        const [json, meta] = serializer.serialize(data);
        return { json, meta };
      },
    },
    hydrate: {
      deserializeData(data) {
        return serializer.deserialize(data.json, data.meta);
      },
    },
  },
});

const link = new RPCLink({
  url: CLIENT_ENV.VITE_API_URL + "/rpc/client",
  plugins: [new SimpleCsrfProtectionLinkPlugin()],
});

const client: ContractRouterClient<ClientAPIContract> = createORPCClient(link);
export const orpc = createTanstackQueryUtils(client);
